import { render, staticRenderFns } from "./ContainerTypeItem.vue?vue&type=template&id=1c806e2c&lang=pug&"
import script from "./ContainerTypeItem.vue?vue&type=script&lang=js&"
export * from "./ContainerTypeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports